import { updatesData } from '@/mocks/home';

const typeStyles: Record<string, string> = {
  '快讯': 'bg-primary-100 text-primary-700',
  '热点': 'bg-accent-100 text-accent-700',
  '回应': 'bg-secondary-100 text-secondary-700',
  '行业': 'bg-background-200 text-foreground-600',
  '爆料': 'bg-primary-100 text-primary-700',
  '预告': 'bg-accent-100 text-accent-700',
  '跟进': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-semibold mb-4">
            <i className="ri-timer-flash-line"></i>
            <span>实时滚动更新</span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            娱乐圈24小时快讯，不错过任何一个热点事件
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {updatesData.map((item) => (
            <div key={item.id} className="flex gap-4 pb-5 last:pb-0">
              <div className="flex-shrink-0 w-16 text-right">
                <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">{item.date}</span>
              </div>

              <div className="relative flex flex-col items-center flex-shrink-0">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-100 z-10"></div>
                {item.id < updatesData.length && (
                  <div className="w-px flex-1 bg-background-300 mt-1.5"></div>
                )}
              </div>

              <div className="flex-1 min-w-0 pb-1">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${typeStyles[item.type] || 'bg-secondary-100 text-secondary-700'}`}>
                    {item.type}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}